import { NamedProperty } from "sprint-common-web";

import { DistributionList } from "../../../common/data/lookup-data-providers/DistributionListsDataProvider";
import {
    AsperaDeliveryEndpointResponse,
    DeliveryEndpointResponse,
    SmartjogDeliveryEndpointResponse,
    SigniantDeliveryEndpointResponse
} from "../../../common/api/orders-api/delivery-endpoint/GetDeliveryEndpointsByIntegratorResponse";
import { DeliveryEndpointType } from "../../../common/types/DeliveryEndpointType";

export interface DeliveryEndpointItem {
    id: string;
    name: string;
    type: DeliveryEndpointType;
    details: DeliveryEndpointDetails;
    updatedDate: string;
    isModified?: boolean;
}

export type DeliveryEndpointDetails =
    | SmartjogDeliveryEndpointDetails
    | AsperaDeliveryEndpointDetails
    | SigniantDeliveryEndpointDetails;

export interface SmartjogDeliveryEndpointDetails {
    type: DeliveryEndpointType.Smartjog;
    distributionLists: DistributionList[];
}

export interface AsperaDeliveryEndpointDetails {
    type: DeliveryEndpointType.Aspera;
    url: string;
    user: string;
    ssmPrivateKeyName: string;
    workspace?: string;
}

export const mapToDeliveryEndpointItem = (item: DeliveryEndpointResponse): DeliveryEndpointItem => {
    return {
        id: item.id,
        name: item.name,
        type: item.type,
        details: mapToDetails(item),
        updatedDate: item.audit.updatedDate
    };
};
export interface SigniantDeliveryEndpointDetails {
    type: DeliveryEndpointType.Signiant;
    destinationStorageProfile: NamedProperty;
    distributionEmail: string;
}

const mapToDetails = (response: DeliveryEndpointResponse) => {
    switch (response.type) {
        case DeliveryEndpointType.Smartjog:
            return mapToSmartjogDeliveryEndpointDetails(response);
        case DeliveryEndpointType.Aspera:
            return mapToAsperaDeliveryEndpointDetails(response);
        case DeliveryEndpointType.Signiant:
            return mapToSigniantDeliveryEndpointDetails(response);
        default: {
            throw new Error("Unsupported delivery endpoint Type");
        }
    }
};

const mapToSmartjogDeliveryEndpointDetails = (
    response: SmartjogDeliveryEndpointResponse
): SmartjogDeliveryEndpointDetails => {
    return {
        type: DeliveryEndpointType.Smartjog,
        distributionLists: response.distributionLists
    };
};

const mapToAsperaDeliveryEndpointDetails = (
    response: AsperaDeliveryEndpointResponse
): AsperaDeliveryEndpointDetails => {
    return {
        type: DeliveryEndpointType.Aspera,
        url: response.url,
        user: response.user,
        ssmPrivateKeyName: response.ssmPrivateKeyName,
        workspace: response.workspace
    };
};

const mapToSigniantDeliveryEndpointDetails = (
    response: SigniantDeliveryEndpointResponse
): SigniantDeliveryEndpointDetails => {
    return {
        type: DeliveryEndpointType.Signiant,
        destinationStorageProfile: response.destinationStorageProfile,
        distributionEmail: response.distributionEmail
    };
};
